import React from 'react';
import { Flex, Box, Text, Button, Link } from 'rebass/styled-components';

const ContactUs = ({ emailUsLink }) => (
  <Flex flexDirection="column" mx={[4, 5]} py={5}>
    <Box>
      <Text fontSize={'28px'} fontWeight="600" mb={3}>
        Contact Us
      </Text>
      <Text fontSize={1} fontWeight="700" fontFamily="lato">
        Looking to learn more?
      </Text>
      <Text fontSize={1} fontFamily="lato" mb={1}>
        Click below to contact the Progentec Clinical Research Team with any
        other questions or comments. We look forward to hearing from you!
      </Text>
      <Link href={`mailto:${emailUsLink}`}>
        <Button variant="main" mt={3}>
          EMAIL US
        </Button>
      </Link>
    </Box>
  </Flex>
);

export default ContactUs;
